import { useEffect } from "react";
import { FaTimes, FaUserMd, FaComments, FaCalendarAlt, FaClock } from "react-icons/fa";

const OneToOneSessionModal = ({ isOpen, onClose }) => {
    useEffect(() => {
        if (isOpen) {
            document.documentElement.style.overflow = "hidden";
            document.body.style.overflow = "hidden";
        } else {
            document.documentElement.style.overflow = "auto";
            document.body.style.overflow = "auto";
        }
        return () => {
            document.documentElement.style.overflow = "auto";
            document.body.style.overflow = "auto";
        };
    }, [isOpen]);

    const handleBookClick = () => {
        window.open("https://neetsupport.com/book-1-on-1-neet-counselling-session", "_blank");
        onClose();
    };

    if (!isOpen) return null;

    return (
        <>
            <div className="fixed inset-0 p-2 sm:p-4 flex items-center justify-center bg-gray-400 bg-opacity-10 backdrop-blur-[2px] z-50 animate-fadeIn">
                <div className="bg-white rounded-lg sm:rounded-xl shadow-2xl w-full max-w-sm sm:max-w-lg max-h-[95vh] sm:max-h-[90vh] overflow-y-auto relative animate-slideUp">
                    {/* Close Button */}
                    <button
                        onClick={onClose}
                        className="absolute top-1 right-1 z-10 text-[#0e605b] hover:text-[#ff9245] bg-white rounded-full p-2 transition-all shadow-md"
                        aria-label="Close modal"
                    >
                        <FaTimes className="text-lg" />
                    </button>

                    {/* Content */}
                    <div className="p-2 sm:p-4">
                        {/* Header */}
                        <div className="text-center mb-2 sm:mb-3">
                            <div className="inline-flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-[#0e605b] to-[#0e605b] rounded-full mb-1 shadow-lg">
                                <FaUserMd className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
                            </div>
                            <h2 className="text-lg sm:text-xl font-bold text-gray-900 mb-1 px-2">
                                Book a <span className="text-[#ff9245]">1:1</span> NEET Guidance Session
                            </h2>
                        </div>

                        {/* Info Grid */}
                        <div className="grid grid-cols-2 sm:grid-cols-2 gap-1.5 sm:gap-2 mb-2">
                            <div className="flex items-center gap-1.5 sm:gap-2 p-1.5 sm:p-2 bg-teal-50 rounded-md border border-teal-100">
                                <div className="bg-gradient-to-br from-[#0e605b] to-[#0a4941] rounded p-1 sm:p-1.5 flex-shrink-0">
                                    <FaComments className="w-3 h-3 sm:w-4 sm:h-4 text-white" />
                                </div>
                                <div>
                                    <h3 className="font-semibold text-[10px] sm:text-xs text-gray-900">Personalized Advice</h3>
                                    <p className="text-[8px] sm:text-[12px] font-semibold text-gray-600">1:1 with NEET experts</p>
                                </div>
                            </div>
                            <div className="flex items-center gap-1.5 sm:gap-2 p-1.5 sm:p-2 bg-orange-50 rounded-md border border-orange-100">
                                <div className="bg-gradient-to-br from-[#ff9245] to-[#ff7f32] rounded p-1 sm:p-1.5 flex-shrink-0">
                                    <FaCalendarAlt className="w-3 h-3 sm:w-4 sm:h-4 text-white" />
                                </div>
                                <div>
                                    <h3 className="font-semibold text-[10px] sm:text-xs text-gray-900">Flexible Slots</h3>
                                    <p className="text-[8px] sm:text-[12px] font-semibold text-gray-600">Book at your convenience</p>
                                </div>
                            </div>
                        </div>
                        <div className="grid grid-cols-2 gap-1.5 sm:gap-2 mb-2">
                            <div className="flex items-center gap-1.5 sm:gap-2 p-1.5 sm:p-2 bg-teal-50 rounded-md border border-teal-100">
                                <div className="bg-gradient-to-br from-[#0e605b] to-[#0a4941] rounded p-1 sm:p-1.5 flex-shrink-0">
                                    <FaClock className="w-3 h-3 sm:w-4 sm:h-4 text-white" />
                                </div>
                                <div>
                                    <h3 className="font-semibold text-[10px] sm:text-xs text-gray-900">30 Min Session</h3>
                                    <p className="text-[8px] sm:text-[12px] font-semibold text-gray-600">Focused guidance</p>
                                </div>
                            </div>
                            <div className="flex items-center gap-1.5 sm:gap-2 p-1.5 sm:p-2 bg-orange-50 rounded-md border border-orange-100">
                                <div className="bg-gradient-to-br from-[#ff9245] to-[#ff7f32] rounded p-1 sm:p-1.5 flex-shrink-0">
                                    <FaUserMd className="w-3 h-3 sm:w-4 sm:h-4 text-white" />
                                </div>
                                <div>
                                    <h3 className="font-semibold text-[10px] sm:text-xs text-gray-900">Top Counselors</h3>
                                    <p className="text-[8px] sm:text-[12px] font-semibold text-gray-600">NEET specialists</p>
                                </div>
                            </div>
                        </div>

                        {/* Info Box */}
                        <div className="grid grid-cols-3 gap-2 sm:gap-3 mb-2 sm:mb-2 p-2 sm:p-3 bg-gradient-to-r from-orange-50 to-yellow-50 rounded-lg border border-orange-200">
                            <div className="flex flex-col items-center justify-center text-center ">
                                <span className="text-lg sm:text-xl ">🗓️</span>
                                <p className="text-[8px] sm:text-[12px] text-gray-600 font-semibold">Flexible Dates</p>
                                <p className="font-bold text-[10px] sm:text-xs text-gray-900">Your Choice</p>
                            </div>
                            <div className="flex flex-col items-center justify-center text-center ">
                                <span className="text-lg sm:text-xl ">⏰</span>
                                <p className="text-[8px] sm:text-[12px] text-gray-600 font-semibold">Duration</p>
                                <p className="font-bold text-[10px] sm:text-xs text-gray-900">30 Min</p>
                            </div>
                            <div className="flex flex-col items-center justify-center text-center ">
                                <span className="text-lg sm:text-xl ">💻</span>
                                <p className="text-[8px] sm:text-[12px] text-gray-600 font-semibold">Platform</p>
                                <p className="font-bold text-[10px] sm:text-xs text-gray-900">Google Meet</p>
                            </div>
                        </div>

                        {/* CTA Button */}
                        <button
                            onClick={handleBookClick}
                            className="w-full py-2 sm:py-3 px-3 sm:px-5 bg-[#0e605b] hover:bg-[#ff9245] text-white font-bold rounded-lg text-xs sm:text-sm transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105 flex items-center justify-center gap-1.5 sm:gap-2 group mb-1.5 sm:mb-2">
                            <span>Book 1:1 Session Now</span>
                            <svg className="w-3 h-3 sm:w-4 sm:h-4 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                            </svg>
                        </button>

                        {/* Footer Note */}
                        <p className="text-center text-[10px] sm:text-xs text-gray-500 px-2">
                            <span className="font-semibold text-[#0e605b]">🎯 Personalized for you!</span> Book your slot and get expert NEET guidance
                        </p>
                    </div>
                </div>
            </div>

            <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        @keyframes slideUp {
          from {
            transform: translateY(20px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out;
        }
        .animate-slideUp {
          animation: slideUp 0.4s ease-out;
        }
      `}</style>
        </>
    );
};

export default OneToOneSessionModal;
